module.exports = __webpack_public_path__ + "static/media/galerija_2019 (24).6cc19f1a.jpg";